export enum ButtonColorEnum {
  common = 'common',
  primary = 'primary',
  warning = 'warning',
  white = 'white',
}
